import type { FunctionComponent } from 'react'
import type { CustomArrowProps } from 'react-slick'
import Slider from 'react-slick'

import styles from './heroV2-carousel.module.scss'
import { Chevron } from '@components/icons/chevron'
import { HeroV2 } from '@contentful-components/hero-v2'
import type { HeroV2SectionFragment } from '@graphql/fragments/HeroV2SectionFragment.graphql'

export const HeroV2Carousel: FunctionComponent<HeroV2CarouselProps> = ({
    heroes,
}) => {
    const NextArrow = ({
        currentSlide,
        slideCount,
        ...props
    }: CustomArrowProps) => (
        <div {...props} className={styles.nextArrow}>
            <Chevron width='20px' direction='right' color='step-cold-steel' />
        </div>
    )

    const PrevArrow = ({
        currentSlide,
        slideCount,
        ...props
    }: CustomArrowProps) => (
        <div {...props} className={styles.prevArrow}>
            <Chevron width='20px' direction='left' color='step-cold-steel' />
        </div>
    )

    return (
        <div className={styles.container}>
            <Slider
                accessibility
                autoplay
                autoplaySpeed={7000}
                infinite={false}
                className={styles.carousel}
                nextArrow={<NextArrow />}
                prevArrow={<PrevArrow />}
            >
                {heroes?.items.map((item, index) => (
                    <HeroV2
                        index={index}
                        isCarousel
                        key={index}
                        layout={item.layout}
                        copyLayout={item.copyLayout}
                        showWinnersBadge={item?.showWinnersBadge}
                        headingPre={item?.headingPre}
                        heading={item?.heading}
                        headingPost={item?.headingPost}
                        headingColor={item?.headingColor}
                        headingColorMobile={item?.headingColorMobile}
                        backgroundType={item?.backgroundType}
                        backgroundColor={item?.backgroundColor}
                        bgVideo={item?.bgVideo}
                        backgroundVideoFit={item?.backgroundVideoFit}
                        backgroundVideoMobile={item?.backgroundVideoMobile}
                        backgroundImageDesktop={item.backgroundImageDesktop}
                        backgroundImageMobile={item.backgroundImageMobile}
                        copy={item.copy}
                        copyColor={item.copyColor}
                        copyColorMobile={item.copyColorMobile}
                        supportingCopy={item.supportingCopy}
                        supportingCopyColor={item.supportingCopyColor}
                        copyContainerPadding={item.copyContainerPadding}
                        button={item.button}
                        secondaryButton={item.secondaryButton}
                        image={item.image}
                        video={item.video}
                        imageAlignment={item.imageAlignment}
                        mediaVisible={item.mediaVisible}
                        mediaType={item.mediaType}
                        hideMediaOnMobile={item.hideMediaOnMobile}
                        showBackgroundBeforeContentNoMobile={
                            item.showBackgroundBeforeContentNoMobile
                        }
                        fetchPriority={
                            index === 0 ? item.fetchPriority : 'auto'
                        }
                    />
                ))}
            </Slider>
        </div>
    )
}

export default HeroV2Carousel

export type HeroV2CarouselProps = Omit<HeroV2SectionFragment, 'sys' | 'type'>
